<template>
  <div class="pagination-box">
    <el-pagination
      :current-page="page"
      :page-size="limit"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      layout="total, sizes, prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
  },
  methods: {
    // 改变每页多少条
    handleSizeChange(value) {
      // 改变每页多少条的时候，页码应该回归到第一页
      this.$emit('pagination', { page: 1, limit: value });
    },
    // 改变页码
    handleCurrentChange(value) {
      this.$emit('pagination', { page: value, limit: this.limit });
    }
  }
}
</script>

<style scoped>
  .pagination-box {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
  }
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue